import React from "react";

export default function Portfolio(){
    return (
        <div className="pg">
            <h1>Featured Web-Based Applications</h1>
            <h3 className="h3">See more on <a className="link" href="https://github.com/mollytreadwell"> GitHub </a>!</h3>
        <div className="portr2">
            <div className="portc"><a className="applink" href="https://molly-treadwellfullstackrestaurantapplication.vercel.app/"><img className="port" src="restaurant.png" alt="restaurant" width="550" height="550"/><br/><h3 className="applink">Restaurant Ordering App</h3></a></div>
            <div className="portc"><a className="applink" href="https://mollytreadwell.github.io/monadnockpg/"><img className="port" src="garden.png" alt="mpgapp" width="550" height="550"/><br/><h3 className="applink"> Monadnock Perennial Gardens Contact Page </h3></a></div>
            <div className="portc"><a className="applink" href="https://mollytreadwell.github.io/badbank/#/"><img className="port" src="badbank2.png" alt="bbapp" width="550" height="550"/><br/><h3 className="applink">Bad Bank Application</h3></a></div>
        </div>
        </div>
    )
}

        /*line 8: <a href="https://mollytreadwell.github.io/runningapp"><img src="race.png" alt="raceapp" width="550" height="300"/></a><br/> */